// A page with no path of its own can still ask for the Desert Book. The 404 page renders in eight places (the
// router's catch-all and the missing-slug branch of seven dynamic routes), and a missing URL can't be listed in
// DESERT_PATHS, so NotFound raises this switch while it is mounted. AppShell reads it beside isDesertPath, and the
// theme and the full Desert footer follow (plan: docs/in-motion/plans/not-found.md).
//
// Limit, stated in the plan: a bad URL typed straight into the browser paints the reference palette first and turns
// Desert once the app mounts. In-site navigation to a missing page has no flash.
import { useEffect, useLayoutEffect } from "react";

let holders = 0;
const listeners = new Set<() => void>();
const notify = () => listeners.forEach((fn) => fn());

export function subscribeDesertOverride(fn: () => void): () => void {
  listeners.add(fn);
  return () => { listeners.delete(fn); };
}

export function desertOverrideActive(): boolean {
  return holders > 0;
}

const useBrowserLayoutEffect = typeof window === "undefined" ? useEffect : useLayoutEffect;

/** Hold the Desert Book theme on for as long as the calling page is mounted. */
export function useDesertOverride(): void {
  useBrowserLayoutEffect(() => {
    holders += 1;
    notify();
    return () => {
      holders -= 1;
      notify();
    };
  }, []);
}
